import type {
  AssistantSettingsState,
  AssistantSettingsUpdatePayload,
} from '@core/intelligence-types';
import { createSingleEntityStore, getSingleEntityActions } from '@core/ngrx-legacy';

export const {
  reducer: AssistantSettingsReducer,
  actions: AssistantSettingsActions,
  selectors: AssistantSettingsSelectors,
  namespace: AssistantSettingsNamespace,
} = createSingleEntityStore<AssistantSettingsState>()('AssistantSettingsState', {
  customActions: adapter => {
    const defaultActions = getSingleEntityActions(adapter);
    return {
      update: (state, payload: AssistantSettingsUpdatePayload) =>
        defaultActions.update(state, payload),

      updateKnowledgeSources: (state, payload: Pick<AssistantSettingsState, 'knowledgeSources'>) =>
        state.data ? adapter.update(state, { knowledgeSources: payload.knowledgeSources }) : state,
    };
  },
});
